import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { motion } from 'framer-motion';
import businessChartIllustration from '../../assets/gg__illustration--business-chart-1.svg';
import shapeBackground from '../../assets/landing/img/shape.png';

const benefits = ['Powered by AI', 'Flexible & Tailored', 'Enterprise Grade'];

export default function About() {
  return (
    <Box
      id="about"
      sx={{
        py: 10,
        backgroundColor: 'grey.50',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Shape */}
      <Box
        component="img"
        src={shapeBackground}
        alt=""
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '40%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'left top',
          opacity: 0.1,
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="lg">
        <Grid container spacing={6} sx={{ alignItems: 'center' }}>
          {/* Image */}
          <Grid size={{ xs: 12, md: 6 }}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Box
                component="img"
                src={businessChartIllustration}
                alt="Business Analytics and Insights"
                sx={{ width: '90%', height: 'auto' }}
              />
            </motion.div>
          </Grid>

          {/* Content */}
          <Grid size={{ xs: 12, md: 6 }}>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '1.75rem', md: '2.25rem' },
                  fontWeight: 700,
                  mb: 3,
                }}
              >
                Empowering Philanthropic Institutions to Make Informed Funding
                Decisions
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                From local foundations to national funders, Grant Guardian is
                trusted by more than 400 organizations across the United States.
              </Typography>

              <List sx={{ mb: 4 }}>
                {benefits.map((benefit, index) => (
                  <ListItem key={index} sx={{ px: 0 }}>
                    <ListItemIcon>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={benefit} />
                  </ListItem>
                ))}
              </List>

              {/* Stats */}
              <Box>
                <Typography
                  variant="h2"
                  color="primary.main"
                  sx={{ fontWeight: 700 }}
                >
                  400+
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Organizations Trust Grant Guardian
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
